import { render } from "./tpl_top_one_bottom_two.vue?vue&type=template&id=7f6a15ec&scoped=true"
import script from "./tpl_top_one_bottom_two.vue?vue&type=script&lang=js"
export * from "./tpl_top_one_bottom_two.vue?vue&type=script&lang=js"

import "./tpl_top_one_bottom_two.vue?vue&type=style&index=0&id=7f6a15ec&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6a15ec"],['__file',"src/views/wap/template/tpl_top_one_bottom_two.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f6a15ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f6a15ec', __exports__)) {
    console.log('reload')
    api.reload('7f6a15ec', __exports__)
  }
  
  module.hot.accept("./tpl_top_one_bottom_two.vue?vue&type=template&id=7f6a15ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('7f6a15ec', render)
  })

}


export default __exports__